// extracted by mini-css-extract-plugin
module.exports = {"case-study-A":"A_case-study-A__dDRiq"};